import * as Effects from 'redux-saga/effects'
import { all, call, put, take } from 'redux-saga/effects'
import { IntegrationAction } from '../../reducers/airbnb/actionNames'
import fetchActionsName, { ActionNames } from '../../utils/FetchActionsName'
import { callFetch } from '../../actions/fetch'
import fetchIntegration from '../../models/Integration/fetchIntegration'
import { IntegrationStatus } from '../../reducers/airbnb'

function* getIntegration() {
  try {
    const actionNames = fetchActionsName(ActionNames.FetchAirbnbIntegration)
    const [{ service }] = yield all([
      take(actionNames.output),
      put(callFetch(actionNames.input, actionNames.output, fetchIntegration)),
    ])

    const integration = yield call(service)

    yield Effects.put({
      type: IntegrationAction.SetIntegration,
      payload: IntegrationStatus.Integrated,
    })

    yield Effects.put({
      type: IntegrationAction.SetSync,
      payload: Number(integration.items.status),
    })

    yield Effects.put({ type: IntegrationAction.GetListings })
  } catch (e) {
    yield Effects.put({
      type: IntegrationAction.SetIntegration,
      payload: IntegrationStatus.NotIntegrated,
    })
  }
}

export default function*() {
  yield Effects.takeLatest(IntegrationAction.GET_STATUS, getIntegration)
}
